import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { EVENT_KEY_SPACE, EVENT_KEY_RETURN } from '../utils/event-key-names';
import HitAreaElement from './styles';

// increase the padding around links/icons/buttons to make them easier to click and implements the proper accessibility
// properties to mimic a button, see: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role
const HitArea = /*#__PURE__*/forwardRef(({
  children,
  colorHover,
  disabled = false,
  display,
  label,
  onClick,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(HitAreaElement, _extends({}, props, {
    ref: ref,
    role: onClick ? 'button' : undefined,
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-label": props['aria-label'] || label || undefined,
    tabIndex: onClick ? '0' : undefined,
    "data-display": display,
    "data-color-hover": colorHover,
    onKeyDown: onClick && !disabled ? event => {
      if (event.key === EVENT_KEY_SPACE || event.key === EVENT_KEY_RETURN) {
        onClick(event);
      }
    } : undefined,
    onClick: disabled ? undefined : onClick
  }), children);
});
HitArea.propTypes = {
  children: PropTypes.node.isRequired,
  colorHover: PropTypes.string,
  disabled: PropTypes.bool,
  display: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func
};
export default HitArea;
//# sourceMappingURL=index.js.map